module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-dialog', {
    attrs: {
      "title": "订单详情",
      "visible": _vm.dialogShowCurrent,
      "width": "50%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogShowCurrent = $event
      },
      "close": _vm.dialogCancel
    }
  }, [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "title": "申报信息一旦提交成功后，不可修改！",
      "type": "warning",
      "closable": false
    }
  }), _vm._v(" "), _vm._l((_vm.fieldArr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list_item"
    }, [_c('div', {
      staticClass: "list_item_key"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "list_item_val"
    }, [_vm._v(_vm._s(item.value))])])
  }), _vm._v(" "), (_vm.memberArr.length) ? [_c('el-divider', {
    attrs: {
      "content-position": "center"
    }
  }, [_vm._v("人员信息")]), _vm._v(" "), _vm._l((_vm.memberArr), function(item, index) {
    return _c('el-card', {
      key: index + 'a',
      staticClass: "box-card"
    }, _vm._l((item), function(item2, index2) {
      return _c('div', {
        key: index2,
        staticClass: "list_item"
      }, [_c('div', {
        staticClass: "list_item_key"
      }, [_vm._v(_vm._s(item2.name))]), _vm._v(" "), _c('div', {
        staticClass: "list_item_val"
      }, [_vm._v(_vm._s(item2.value))])])
    }), 0)
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.dialogCancel
    }
  }, [_vm._v("返回修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.dialogConfirm
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('div', {
    staticClass: "footer_tips"
  })], 1)], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9414abc2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderDetailDialog.vue
// module id = 1302
// module chunks = 0